import React from "react";
import { List, ListItem } from "../core/pdf/types";

export interface ListState {
	list: List,
	number: number,
	style: string,

	addItem: (after: ListItem) => void,
}

export const ListContext = React.createContext<ListState | undefined>(undefined);;

export function useList() {
	return React.useContext(ListContext);
}
